import moment from 'moment-timezone'

export function getFormatDate(date) {
  if (date) {
    return moment(date).format('HH:mm')
  }
  return ''
}

export function getSecondsToTime(secs) {
  let format = 'mm:ss'
  if (secs > 3600) {
    format = 'HH:mm:ss'
  }
  return moment.utc(secs * 1000).format(format) 
}

export function numberWithSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function getShortId(id) {
  const idStr = id.toString()
  if (idStr.length <= 4) {
    return idStr
  }
  return idStr.substr(idStr.length - 4)
}
